<template>
  <div>
    <div class="chartheight" ref="chart"></div>
  </div>
</template>

<script>
export default {
  props: {
    position: null,
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        {
          value: this.position.financeCount,
          name: "金融从业者",
          itemStyle: { color: "#E0AAF0" },
        },
        {
          value: this.position.medicalStaffCount,
          name: "医务人员",
          itemStyle: { color: "#6F5EE4" },
        },
        {
          value: this.position.civilServantCount,
          name: "公务员",
          itemStyle: { color: "#FD8C6C" },
        },
        {
          value: this.position.whiteCollarCount,
          name: "公司职员",
          itemStyle: { color: "#2E90D1" },
        },
        {
          value: this.position.workerCount,
          name: "工人",
          itemStyle: { color: "#F75881" },
        },
        {
          value: this.position.teacherCount,
          name: "教职工",
          itemStyle: { color: "#2DB9E3" },
        },
        {
          value: this.position.farmerCount,
          name: "农民",
          itemStyle: { color: "#90E3A9" },
        },
        {
          value: this.position.studentCount,
          name: "学生",
          itemStyle: { color: "#FED54B" },
        }, 
        {
          value: this.position.selfEmployedOrWaitressCount,
          // name: "个体或服务业从业者",
          name: "个体或服务业",
          itemStyle: { color: "#EE0000" },
        },
        {
          value: this.position.cityWorkerCount,
          name: "城市其他职业",
          itemStyle: { color: "#B3EE3A" },
        },
        {
          value: this.position.countrysideWorkerCount,
          name: "农村其他职业",
          itemStyle: { color: "#CDC673" },
        },
        {
          value: this.position.unknownProfessionCount,
          name: "未识别",
          itemStyle: { color: "#F4F8FF" },
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    initChart() {
      this.myCharts = this.$echarts.init(this.$refs.chart);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      let options = {
        // 提示框组件
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} 人 ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: -5,
          top: 0,
          icon: "circle",
          data: [
            "金融从业者",
            "医务人员",
            "公务员",
            "公司职员",
            "工人",
            "教职工",
            "农民",
            "学生",
            // "个体或服务业从业者",
            "个体或服务业",
            "城市其他职业",
            "农村其他职业",
            "未识别",
          ],
          itemGap: 10,
          itemWidth: 8,
          itemHeight: 8,
        },
        // 系列列表。每个系列通过 type 决定自己的图表类型
        series: {
          name: "职业",
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: true,
          label: {
            show: false,
            formatter: "{b}: {@2012} ({d}%)",
            color:"#333"
            // position: 'center'
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "14",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: false,
          },
          data: data,
        },
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>

<style scoped lang="scss">
.chartheight {
  height: 300px;
  margin-top: 10px;
  @media screen and (max-width: 1658px) {
    margin-top: 30px;
    height: 250px;
  }
  @media screen and (max-width: 1340px) {
    margin-top: 20px;
    height: 250px;
  }
}
</style>
